import always from 'ramda/es/always';
import evolve from 'ramda/es/evolve';
import omit from 'ramda/es/omit';
import assoc from 'ramda/es/assoc';

import {
  BUILDINGS_FILTER_REQUEST,
  BUILDINGS_FILTER_SUCCESS,
  BUILDINGS_FILTER_FAILURE,
  BUILDINGS_FILTER_CLEAR,
  BUILDINGS_FILTER_DELETE,
  BUILDINGS_FILTER_SET,
  BUILDINGS_FILTER_UPDATE,
} from 'app/actions/reports/filters/buildings';


const defaultState = {
  data: {},
  selected: {},
  loading: true,
  active: false,
};

const buildings = (state = defaultState, { type, payload }) => {
  switch (type) {
    case BUILDINGS_FILTER_REQUEST: {
      return { ...state, loading: true };
    }
    case BUILDINGS_FILTER_SUCCESS: {
      return evolve({
        data: always(payload),
        loading: always(false),
      }, state);
    }
    case BUILDINGS_FILTER_FAILURE: {
      return { ...state, loading: false };
    }
    case BUILDINGS_FILTER_CLEAR: {
      return defaultState;
    }
    case BUILDINGS_FILTER_DELETE: {
      return evolve({ selected: omit(payload) }, state);
    }
    case BUILDINGS_FILTER_SET: {
      return assoc('selected', payload, state);
    }
    case BUILDINGS_FILTER_UPDATE: {
      return { ...state, ...payload };
    }
    default:
  }
  return state;
};

export default buildings;
